import * as actions from "store/actions/company/edit";
import IMei from "Types/IMei";

export interface CompanyEditState extends IMei {
	loading: boolean;
	errors: any;
}

const initialState: CompanyEditState = {
	loading: false,
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_COMPANY: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_COMPANY_SUCCESS: {
			return {
				...initialState,
				...payload,
				item: payload
			};
		}
		case actions.GET_COMPANY_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_COMPANY: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_COMPANY_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_COMPANY_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
